<template>
    <div class="valid-input-wrapper">
        <label class="valid-input-label" v-if="!!label"> <span :class="{ 'valid-input-required': required }">*</span> {{ $t(label) }}</label>
        <div class="valid-input-right">
            <input
                class="valid-input"
                :class="{ 'valid-input-invalid': !isValided }"
                ref="inputRef"
                :placeholder="$t(placeholder)"
                v-model="innerValue"
                :type="inputType"
                @input="inputHandler"
                @blur="inputHandler"
            />
            <div class="valid-input-tip" v-show="!isValided && !!errorTips">{{ $t(errorTips) }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ValidableInput",
    props: ["value", "type", "label", "required", "pattern", "placeholder", "errorTips"],
    data() {
        return {
            isValided: true,
            innerValue: this.value ? this.value.value : ""
        };
    },
    computed: {
        inputType() {
            return this.type || "text";
        }
    },
    watch: {
        value: {
            handler() {
                this.innerValue = this.value ? this.value.value : "";
                this.isValided = this.value.isValided != null ? this.value.isValided : true;
            },
            deep: true
        }
    },
    methods: {
        inputHandler() {
            // 检查是否合法
            this.checkValid();

            // 兼容v-modal
            this.$emit("input", {
                value: this.innerValue,
                isValided: this.isValided
            });
        },
        checkValid() {
            const inputValue = this.innerValue;
            inputValue.trim();
            if (!inputValue && this.required) {
                this.isValided = false;
            } else if (this.pattern && inputValue) {
                const regexp = new RegExp(this.pattern);
                this.isValided = regexp.test(inputValue);
            } else {
                this.isValided = true;
            }
        },
        focus() {
            this.$refs.inputRef.focus();
        },
        blur() {
            this.$refs.inputRef.blur();
        }
    }
};
</script>

<style lang="less" scoped>
.valid-input-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 30px;
}

.valid-input-label {
    width: 120px;
    margin-right: 8px;
    text-align: right;
}

.valid-input-required {
    color: #fe0931;
}

.valid-input-right {
    position: relative;
}

.valid-input {
    border-radius: 4px;
    padding: 7px 8px 7px 8px;
    background: #fff;
    width: 320px;
    border: solid 1px #d8e4f0;
    box-sizing: border-box;
    font-size: 12px;
    outline: none;
    &::placeholder {
        color: #9b9ba3;
    }
    &:focus {
        border-color: #2088f3;
        &::placeholder {
            color: #c9c9c9;
        }
    }
}

.valid-input-invalid {
    border-color: #e03838 !important;
}

.valid-input-tip {
    color: #e03838;
    position: absolute;
    white-space: nowrap;
    left: 0;
    font-size: 12px;
}
</style>
